var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "text-block blok-markdown",
    },
    [
      _c("div", {
        staticClass: "inner-block",
        class: _vm.styleClasses,
        domProps: { innerHTML: _vm._s(_vm.htmlText) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }